import { Workflow } from 'lucide-react'
import { Link } from 'react-router-dom'

import { LoginForm } from '@/components/auth/LoginForm'

export function LoginPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-50 px-4">
      <div className="w-full max-w-md space-y-6">
        <div className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary-600">
            <Workflow className="h-6 w-6 text-white" />
          </div>
          <h1 className="text-3xl font-bold">Generic WorkFlow</h1>
          <p className="mt-2 text-neutral-500">
            Multi-tenant workflow engine
          </p>
        </div>

        <LoginForm />

        <p className="text-center text-sm text-neutral-500">
          Don't have an account?{' '}
          <Link to="/register" className="text-primary-600 hover:underline">
            Create account
          </Link>
        </p>
      </div>
    </div>
  )
}